import { createContext, useContext } from 'react';
import { UseRachelChatReturn } from '../rachel.types';

export const RachelChatContext = createContext<UseRachelChatReturn | null>(null);

export const useRachelChatContext = (): UseRachelChatReturn => {
  const context = useContext(RachelChatContext);
  if (!context) {
    throw new Error('useRachelChatContext must be used within a RachelChatProvider');
  }
  return context;
};
